import React from "react";

// 3D floating decorative shapes used in hero / page headers
export function FloatingShapes({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {/* Big blob */}
      <div
        className="absolute -top-20 -right-20 w-[420px] h-[420px] rounded-full opacity-60 animate-float-slow"
        style={{
          background:
            "radial-gradient(circle at 30% 30%, rgba(222,108,93,0.55), rgba(222,108,93,0) 60%), radial-gradient(circle at 70% 70%, rgba(143,184,202,0.45), rgba(143,184,202,0) 60%)",
          filter: "blur(20px)",
        }}
      />
      {/* Small disc */}
      <div
        className="absolute top-32 left-[10%] w-32 h-32 rounded-3xl animate-float-medium"
        style={{
          background: "linear-gradient(135deg, #DE6C5D 0%, #F0A48F 100%)",
          transform: "rotate(18deg)",
          boxShadow: "0 30px 60px -20px rgba(222,108,93,0.45)",
        }}
      />
      {/* Donut ring */}
      <div
        className="absolute bottom-10 right-[14%] w-40 h-40 rounded-full animate-float-slow"
        style={{
          background: "conic-gradient(from 180deg, #8FB8CA, #B7D2DE, #8FB8CA)",
          maskImage: "radial-gradient(circle, transparent 38%, black 40%)",
          WebkitMaskImage: "radial-gradient(circle, transparent 38%, black 40%)",
          opacity: 0.55,
        }}
      />
      {/* Square */}
      <div
        className="absolute bottom-24 left-[18%] w-24 h-24 rounded-2xl animate-float-medium"
        style={{
          background: "linear-gradient(135deg, rgba(143,184,202,0.35) 0%, rgba(183,210,222,0.25) 100%)",
          transform: "rotate(-12deg)",
          boxShadow: "0 25px 50px -15px rgba(11,39,66,0.18)",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
          border: "1px solid rgba(255,255,255,0.4)",
        }}
      />
    </div>
  );
}

export function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative pt-32 pb-16 sm:pt-40 sm:pb-20 overflow-hidden">
      <FloatingShapes />
      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center">
        {eyebrow && (
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/70 backdrop-blur border border-ocean/10 text-xs uppercase tracking-[0.2em] text-coral font-semibold mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-coral animate-pulse"></span>
            {eyebrow}
          </div>
        )}
        <h1 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ocean leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-base sm:text-lg text-ocean/65 max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}
